var map = {
	"./alert.svg": "4c89",
	"./amex.svg": "a572",
	"./bank-cards.svg": "12f0",
	"./briefcase.svg": "19b6",
	"./card-back.svg": "e892",
	"./circle-solid.svg": "2e6d",
	"./conference.svg": "b243",
	"./contract.svg": "3d49",
	"./default-card.svg": "0eea",
	"./digital-risks-logo-color.svg": "f09a",
	"./digital-risks-logo-icon.svg": "3c21",
	"./diners.svg": "227a",
	"./direct-debit.svg": "1a20",
	"./email.svg": "da8d",
	"./employee.svg": "0c53",
	"./envelope.svg": "c22f",
	"./google.svg": "4460",
	"./handshake.svg": "d9c9",
	"./mastercard.svg": "0be0",
	"./men.svg": "e496",
	"./person.svg": "7c75",
	"./save-file.svg": "ff9c",
	"./star.svg": "ec6f",
	"./starling-logo.svg": "5a89",
	"./user-group.svg": "fe5d",
	"./user.svg": "4d66",
	"./visa.svg": "4c1f",
	"./women.svg": "abcd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7902";